import { render, staticRenderFns } from "./StockUpdates.vue?vue&type=template&id=73a2e3e0&scoped=true"
import script from "./StockUpdates.vue?vue&type=script&lang=js"
export * from "./StockUpdates.vue?vue&type=script&lang=js"
import style0 from "./StockUpdates.vue?vue&type=style&index=0&id=73a2e3e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a2e3e0",
  null
  
)

export default component.exports